// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Bs2-I"};